module.exports = __webpack_public_path__ + "media/mypage/images/status-active-13acaeac533451c846005bc4260734f4.gif";